// Function to load the Zendesk snippet
function loadZendeskSnippet() {
    var zendeskScript = document.createElement('script');
    zendeskScript.id = 'ze-snippet';
    zendeskScript.src = 'https://static.zdassets.com/ekr/snippet.js?key=3211ef2a-b483-4d80-b78e-bce3dffdb622';
    
    // Once the script is loaded, configure the widget
    zendeskScript.onload = function() {
        configureZendeskWidget();
    };

    document.head.appendChild(zendeskScript);
}

// Function to configure the Zendesk widget
function configureZendeskWidget() {
    zE('webWidget:on', 'chat:departmentStatus', function(dept) {
        var settings = {
            webWidget: {
                contactOptions: { enabled: true },
                contactForm: { title: { '*': 'Send en melding' } },
                chat: {},
                launcher: {}
            }
        };

        if (dept.name === 'Multiclient Team 1') {
            if (dept.status === 'online') {
                settings.webWidget.contactOptions = {
                    contactButton: { '*': 'Send en melding' },
                    chatLabelOnline: { '*': 'Live chat' },
                    contactFormLabel: { '*': 'Send en melding' }
                };
                settings.webWidget.chat = {
                    title: { '*': 'Chat med oss' },
                    departments: { enabled: [''], select: 'Multiclient Team 1' },
                    menuOptions: { emailTranscript: false },
                    suppress: false
                };
                settings.webWidget.launcher = { chatLabel: { '*': 'Chat' } };
            } else {
                settings.webWidget.contactOptions.contactFormLabel = { '*': 'Send en melding' };
                settings.webWidget.chat.suppress = true;
                settings.webWidget.launcher.label = { '*': 'Kontakt' };
            }
        }

        zE('webWidget', 'updateSettings', settings);
    });

    // Set Locale
    zE('webWidget', 'setLocale', 'no');
}

 window.zESettings = {
    webWidget: {
      offset: {
        horizontal: '-10px',
        vertical: '54px',
        mobile: {
          horizontal: '-10px',
          vertical: '35px'
        }
      }
    }
  };

// Load the Zendesk snippet
loadZendeskSnippet();